import { Navigate, Route, Routes } from 'react-router-dom';

import { routes } from '@blockpulse3/data/shared';
import { CompanyDashboardView, DocumentsView } from '@blockpulse3/web-client/dashboard';
import {
  FundraisingView,
  NewCrowdfundingFundraisingCapitalFixedBankDetails,
  NewCrowdfundingFundraisingCreate,
  NewCrowdfundingFundraisingDocumentation,
  NewCrowdfundingFundraisingLayout,
  NewCrowdfundingFundraisingParameters,
  NewCrowdfundingFundraisingSummary,
  NewPrivateFundraisingCapitalFixedBankDetails,
  NewPrivateFundraisingCreate,
  NewPrivateFundraisingDocumentation,
  NewPrivateFundraisingLayout,
  NewPrivateFundraisingParameters,
  NewPrivateFundraisingSubscribers,
  NewPrivateFundraisingSummary,
} from '@blockpulse3/web-client/fundraising';
import { OptionView } from '@blockpulse3/web-client/option';
import { ShareholdingView } from '@blockpulse3/web-client/shareholding';
import { SubscriptionView } from '@blockpulse3/web-client/subscription';
import { WorkspaceSettingsView } from '@blockpulse3/web-client/workspace';

import { AppLayout } from '../layouts';

type Props = unknown;

/**
 * CompanyWorkspaceRoutes.
 * Renders all company related routes, set active workspace.
 *
 * @param {Props}
 * @returns {JSX.Element}
 */
export function CompanyWorkspaceRoutes(): JSX.Element {
  const fundraisingPrivateRoutes = routes.workspace.fundraising.private;
  const fundraisingCrowdfundingRoutes = routes.workspace.fundraising.crowdfunding;

  return (
    <Routes>
      <Route element={<NewPrivateFundraisingLayout />}>
        <Route
          element={<NewPrivateFundraisingCreate />}
          path={fundraisingPrivateRoutes.create.href}
        />
        <Route
          element={<NewPrivateFundraisingParameters />}
          path={fundraisingPrivateRoutes.parameters.href}
        />
        <Route
          element={<NewPrivateFundraisingDocumentation />}
          path={fundraisingPrivateRoutes.documentation.href}
        />
        <Route
          element={<NewPrivateFundraisingCapitalFixedBankDetails />}
          path={fundraisingPrivateRoutes.iban.href}
        />
        <Route
          element={<NewPrivateFundraisingSubscribers />}
          path={fundraisingPrivateRoutes.subscribers.href}
        />
        <Route
          element={<NewPrivateFundraisingSummary />}
          path={fundraisingPrivateRoutes.summary.href}
        />
      </Route>
      <Route element={<NewCrowdfundingFundraisingLayout />}>
        <Route
          element={<NewCrowdfundingFundraisingCreate />}
          path={fundraisingCrowdfundingRoutes.create.href}
        />
        <Route
          element={<NewCrowdfundingFundraisingParameters />}
          path={fundraisingCrowdfundingRoutes.parameters.href}
        />
        <Route
          element={<NewCrowdfundingFundraisingDocumentation />}
          path={fundraisingCrowdfundingRoutes.documentation.href}
        />
        <Route
          element={<NewCrowdfundingFundraisingCapitalFixedBankDetails />}
          path={fundraisingCrowdfundingRoutes.iban.href}
        />
        <Route
          element={<NewCrowdfundingFundraisingSummary />}
          path={fundraisingCrowdfundingRoutes.summary.href}
        />
      </Route>
      <Route element={<AppLayout />}>
        <Route index element={<CompanyDashboardView />} />
        <Route element={<WorkspaceSettingsView />} path={routes.workspace.settings.href} />
        <Route element={<DocumentsView />} path={routes.workspace.documents.href} />
        <Route element={<ShareholdingView />} path={routes.workspace.captable.href} />
        <Route element={<FundraisingView />} path={routes.workspace.fundraising.href} />
        <Route element={<OptionView />} path={routes.workspace.option.href} />
        <Route element={<SubscriptionView />} path={routes.workspace.subscription.href} />
      </Route>
      <Route element={<Navigate replace to={routes.me.href} />} path="*" />
    </Routes>
  );
}

export type CompanyWorkspaceRoutesProps = Props;
